export var TypeOverlayOpacity;
(function (TypeOverlayOpacity) {
    TypeOverlayOpacity["Light"] = "light";
    TypeOverlayOpacity["Dark"] = "dark";
})(TypeOverlayOpacity || (TypeOverlayOpacity = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/TypeOverlayOpacity.ts
// module id = 503
// module chunks = 3